import { Component, ViewEncapsulation, computed, input } from '@angular/core';
import {
  hasFilledNavIconPair,
  toFilledNavIcon,
} from '@core/shell/nav-icon-weight.utils';

/**
 * Idle + filled Iconify fijos; activo solo con CSS (opacity).
 * Evita mutar `data-icon` (Iconify CDN no re-escanea el SVG).
 *
 * `ViewEncapsulation.None`: Iconify reemplaza `<span>` por `<svg>` sin
 * atributos `_ngcontent`, así que el opacity del pair debe ser global
 * (scoped por `.nav-icon-pair`).
 */
@Component({
  selector: 'app-nav-icon-pair',
  standalone: true,
  template: `
    <span
      class="iconify nav-icon-pair__idle"
      [attr.class]="'iconify nav-icon-pair__idle' + (iconClass() ? ' ' + iconClass() : '')"
      [attr.data-icon]="idleIcon()"
      aria-hidden="true"
    ></span>
    @if (hasPair()) {
      <span
        class="iconify nav-icon-pair__filled"
        [attr.class]="'iconify nav-icon-pair__filled' + (iconClass() ? ' ' + iconClass() : '')"
        [attr.data-icon]="filledIcon()"
        aria-hidden="true"
      ></span>
    }
  `,
  styleUrl: './nav-icon-pair.component.scss',
  encapsulation: ViewEncapsulation.None,
  host: {
    class: 'nav-icon-pair',
    '[class.nav-icon-pair--active]': 'active()',
    '[class.nav-icon-pair--solo]': '!hasPair()',
    '[attr.aria-hidden]': 'true',
  },
})
export class NavIconPairComponent {
  /** Iconify id idle (p. ej. `solar:home-2-line-duotone`). */
  readonly icon = input.required<string>();
  /** Estado seleccionado: muestra la variante filled. */
  readonly active = input(false);
  /** Clases extra en cada glifo (p. ej. `icon-menu-item__icon`). */
  readonly iconClass = input('');

  readonly idleIcon = computed(() => (this.icon() ?? '').trim());
  readonly filledIcon = computed(() => toFilledNavIcon(this.idleIcon()));
  readonly hasPair = computed(() => hasFilledNavIconPair(this.idleIcon()));
}
